(function () {
  const isMobile = () =>
    window.matchMedia('(hover: none), (pointer: coarse), (max-width: 767px)').matches;

  // Close all open tooltips
  function closeAll() {
    document.querySelectorAll('.rrp-icon.is-open').forEach(el => {
      el.classList.remove('is-open');
    });
  }

  // Intercept and suppress navigation when tapping the icon on mobile
  const INTERCEPT_EVENTS = [
    'click',
    'auxclick',
    'mousedown',
    'mouseup',
    'pointerdown',
    'pointerup',
    'touchstart',
    'touchend'
  ];

  function interceptIfIcon(e) {
    if (!isMobile()) return;
    const icon = e.target && e.target.closest && e.target.closest('.rrp-icon');
    if (!icon) return;

    // Hard-stop *everything* so product/card listeners never see this
    e.preventDefault();
    // Some frameworks add multiple listeners; stopImmediatePropagation helps here
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    e.stopPropagation();

    // If inside a link, belt-and-braces: cancel that link's next click, too.
    const link = icon.closest('a');
    if (link) {
      const killOnce = (ev) => {
        ev.preventDefault();
        if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
        ev.stopPropagation();
        link.removeEventListener('click', killOnce, true);
      };
      link.addEventListener('click', killOnce, true);
    }

    // Toggle tooltip (only on the initial "down"/"start" or "click" event)
    // We gate on 'click' and 'touchend'/'pointerup' to avoid double toggles.
    const type = e.type;
    const toggleNow = type === 'click' || type === 'touchend' || type === 'pointerup';
    if (toggleNow) {
      const willOpen = !icon.classList.contains('is-open');
      closeAll();
      if (willOpen) icon.classList.add('is-open');
    }
  }

  // Install capture-phase interceptors for all relevant events
  INTERCEPT_EVENTS.forEach((evtName) => {
    document.addEventListener(evtName, interceptIfIcon, { capture: true, passive: false });
  });

  // Close when tapping outside (capture so we see it before card handlers)
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    const icon = e.target.closest?.('.rrp-icon');
    if (!icon) closeAll();
  }, { capture: true, passive: false });

  // Optional: close tooltip when pressing Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });
})();